import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Mainlayout from "./Mainlayout.js";
import Dummy from "./common/dummy/Dummy.js";

import SnapEats from "./component/singleWork/SnapEats.js";
import Tatoo from "./component/singleWork/Tatoo.js";
import Stackoverflow from "./component/singleWork/Stackoverflow.js";
import Chatt from "./component/singleWork/Chatt.js";
import SimplyHome from "./component/singleWork/SimplyHome.js";
import SweetHome from "./component/singleWork/SweetHome.js";




function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [projectPreloader, setProjectPreloader] = useState(true);

  useEffect(() => {
    (
      async () => {
        setTimeout(() => {
          setIsLoading(false);
          window.scrollTo(0, 0);
        }, 2000);
      }
    )();
  }, []);



  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Mainlayout isLoading={isLoading} />} />
        <Route path="/project/snapeats" element={<ProjectDetailOne projectPreloader={projectPreloader} setProjectPreloader={setProjectPreloader} />} />
        <Route path="/project/tatoo" element={<ProjectDetailTwo projectPreloader={projectPreloader} setProjectPreloader={setProjectPreloader} />} />
        <Route path="/project/stackoverflow" element={<ProjectDetailThree projectPreloader={projectPreloader} setProjectPreloader={setProjectPreloader} />} />
        <Route path="/project/snappychat" element={<ProjectDetailFour projectPreloader={projectPreloader} setProjectPreloader={setProjectPreloader} />} />
        <Route path="/project/simplyhome" element={<ProjectDetailFive projectPreloader={projectPreloader} setProjectPreloader={setProjectPreloader} />} />
        <Route path="/project/sweethome" element={<ProjectDetailSix projectPreloader={projectPreloader} setProjectPreloader={setProjectPreloader} />} />
      </Routes>
    </BrowserRouter>
  );
}

function ProjectDetailOne({ projectPreloader, setProjectPreloader }) {

  useEffect(() => {
    setProjectPreloader(true);

    const timeout = setTimeout(() => {
      setProjectPreloader(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    projectPreloader ? <Dummy /> : <SnapEats />
  );
}

function ProjectDetailTwo({ projectPreloader, setProjectPreloader }) {

  useEffect(() => {
    setProjectPreloader(true);

    const timeout = setTimeout(() => {
      setProjectPreloader(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    projectPreloader ? <Dummy /> : <Tatoo />
  );
}

function ProjectDetailThree({ projectPreloader, setProjectPreloader }) {

  useEffect(() => {
    setProjectPreloader(true);

    const timeout = setTimeout(() => {
      setProjectPreloader(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    projectPreloader ? <Dummy /> : <Stackoverflow />
  );
}

function ProjectDetailFour({ projectPreloader, setProjectPreloader }) {

  useEffect(() => {
    setProjectPreloader(true);

    const timeout = setTimeout(() => {
      setProjectPreloader(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    projectPreloader ? <Dummy /> : <Chatt />
  );
}

function ProjectDetailFive({ projectPreloader, setProjectPreloader }) {

  useEffect(() => {
    setProjectPreloader(true);

    const timeout = setTimeout(() => {
      setProjectPreloader(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    projectPreloader ? <Dummy /> : <SimplyHome />
  );
}

function ProjectDetailSix({ projectPreloader, setProjectPreloader }) {

  useEffect(() => {
    setProjectPreloader(true);

    const timeout = setTimeout(() => {
      setProjectPreloader(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    projectPreloader ? <Dummy /> : <SweetHome />
  );
}

export default App;
